export default __webpack_public_path__ + "static/media/instrccionesprofuturo.4610ebf9.png";